<script lang="ts">
  import type { Rewards, RewardDetails, CashbackLocationType } from '$types';
  export let rewards: Rewards;
  export let reward_text: string;
  export let reward_text_title: string = '';
  export let cashbackLocationType: CashbackLocationType;

  const rewardKeys = ['first_visit', 'standard'] as const;
  type RewardKey = (typeof rewardKeys)[number];

  function getReward(key: RewardKey): RewardDetails {
    return rewards[key];
  }
</script>

{#if rewards.cashback_text}
  <span class="cashback_text">{rewards.cashback_text}</span>
{:else}
  <div class="reward">
    <div>
      {#if reward_text_title}
        <span class="title">{reward_text_title}</span>
      {:else}
        <span class="title">{reward_text}</span>
      {/if}
    </div>

    {#if rewards.first_visit.rate && rewards.first_visit.enabled && rewards.first_visit.rate !== rewards.standard.rate}
      <span>
        Første gang:
        <b>{rewards.first_visit.rate} %</b>
      </span>
    {/if}

    {#if rewards.first_visit.enabled}
      <span>
        {rewards.first_visit.rate !== rewards.standard.rate ? 'Herefter: ' : reward_text + ': '}
        <strong>{rewards.standard.rate}</strong> %
      </span>
    {:else}
      <span>{reward_text} <strong>{rewards.standard.rate}</strong> %</span>
    {/if}
  </div>
{/if}

{#if cashbackLocationType.value}
  <div class="cashback_type">
    {cashbackLocationType.description}
  </div>
{/if}

{#if rewards.standard.minimum_spend || rewards.standard.maximum_reward || rewards.first_visit.minimum_spend || rewards.first_visit.maximum_reward}
  <div class="reward-conditions">
    {#each rewardKeys as rewardType}
      {#if getReward(rewardType).minimum_spend || getReward(rewardType).maximum_reward}
        <div>
          <p class="title">{rewardType === 'first_visit' ? 'Første gang:' : 'Herefter:'}</p>

          {#if getReward(rewardType).minimum_spend}
            <p>
              Du skal minimum købe for <span>{getReward(rewardType).minimum_spend} kr.</span>
              for at optjene {reward_text}
            </p>
          {/if}

          {#if getReward(rewardType).maximum_reward}
            <p>
              Du kan optjene max <span>{getReward(rewardType).maximum_reward} kr.</span>
              {rewardType === 'first_visit' ? 'på dit første køb.' : 'pr. køb.'}
            </p>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}
